import { render, staticRenderFns } from "./edit2.vue?vue&type=template&id=5ec6a56c&scoped=true"
import script from "./edit2.vue?vue&type=script&lang=js"
export * from "./edit2.vue?vue&type=script&lang=js"
import style0 from "./edit2.vue?vue&type=style&index=0&id=5ec6a56c&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec6a56c",
  null
  
)

export default component.exports